<div class="container-fluid" *ngIf="visible">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-header">
                    <h5>Message List</h5>
                </div>
                    <div class="card-body">
                        <div class="btn-popup pull-right">
                        </div>
                            <div class="custom-datatable">
                                <form>
                                    <div class="mb-3">
                                    </div>
                                </form>
                                <button class="btn btn-primary me-1 mb-3" style="float: right;"(click)="moveToMainPage()">Back</button>
                                    <div class="clearfix"></div>
                                        <table class="table table-striped" >
                                            <thead>
                                                <tr>
                                                    <!-- <th scope="col" sortable="id" (sort)="onSort($event)">Id</th> -->
                                                    <th scope="col" sortable="channel_id" (sort)="onSort($event)">Channel Name</th>
                                                    <th scope="col" sortable="msg" (sort)="onSort($event)">Message</th>
                                                    <th scope="col" sortable="image" (sort)="onSort($event)">Image</th>
                                                    <th scope="col" sortable="urls" (sort)="onSort($event)">Urls</th>
                                                    <th scope="col" sortable="date_added" (sort)="onSort($event)">Date added</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of viewpages">
                                                        <!-- <td scope="row">{{item.id}}</td>                             -->
                                                        <td scope="row">{{item.message_history.name}}</td>
                                                        <td scope="row">{{item.message}}</td>
                                                        <td scope="row">{{item.image}}</td>
                                                        <td scope="row">{{item.urls}}</td>
                                                        <td scope="row">{{item.date_added}}</td>
                                                     
                                                        
                                                    </tr>
                                                </tbody>
                                        </table>
                                        <div class="d-flex justify-content-center p-2">
                                            <ngb-pagination [(page)]="page" [pageSize]="pageSize" [collectionSize]="viewpages.length"></ngb-pagination>  
                                        </div>
                            </div>
                    </div>
            </div>
        </div>
    </div>
</div>
